/** Messages keeps the open conversation (or System row), the group and the search in the address. */
import { z } from 'zod'
import { systemAboutOf, threadGroups } from '@/core/communications'

export const messagesSearchSchema = z.object({
  /**
   * The open conversation: a contact's id. An address typed by hand
   * (`?with=100021`) reads as a number, so accept that too.
   */
  with: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
  /** The open System row: "location-100018" or "cleaner-100042". */
  about: z
    .string()
    .refine((key) => systemAboutOf(key) !== null)
    .optional()
    .catch(undefined),
  group: z.enum(threadGroups).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
})
export type MessagesSearch = z.infer<typeof messagesSearchSchema>
